import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderCheckingStatusInfo from './OrderCheckingStatusInfo';
import OrderConfirmedStatusInfo from './OrderConfirmedStatusInfo';
import OrderDeniedStatusInfo from './OrderDeniedStatusInfo';

interface OrderStatusInfoProps {
    orderEditViewStore: OrderEditViewStore;
}

const OrderStatusInfo: React.FC<OrderStatusInfoProps> = observer(({ orderEditViewStore }) => {
    const { insertedOrder, setIsOrderCartDrawerOpen } = orderEditViewStore;

    const closeOrderCartDrawer = () => {
        setIsOrderCartDrawerOpen(false);
    }

    if (insertedOrder!.isConfirmed === true) {
        return <OrderConfirmedStatusInfo closeOrderCartDrawer={closeOrderCartDrawer} />
    }
    else if (insertedOrder!.isConfirmed === false) {
        return <OrderDeniedStatusInfo closeOrderCartDrawer={closeOrderCartDrawer} />
    }
    else {
        return <OrderCheckingStatusInfo />
    }
})

export default OrderStatusInfo;